import React, { useState, useEffect } from 'react';
import { getVacancyTemplates } from '../../../api/getApi'
import styles from './vacancyManagerTemplates.module.scss'
import TemplateTabs from './TemplateTabs/TemplateTabs';
import VacancyTypeSwitcher from '../VacancyTypeSwitcher/VacancyTypeSwitcher';
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import VacancyTemplateForm from './VacancyTemplateForms/VacancyTemplateForm';
import { useDispatch, useSelector } from 'react-redux'
import { setTemplateType } from '../../../redux/vacancyManager/vacancyManager.action'

import { useNotify } from '../../../hooks/useNotify'
const VacancyManagerTemplates = () => {
    const { notify } = useNotify()
    const dispatch = useDispatch()
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(false)
    const { vacancyType } = useSelector(({ vacancies }) => vacancies)
    const chosedTemplate = useSelector(({ vacancies }) => vacancies.templateType)

    useEffect(() => {
        const getTemplates = async () => {
            setLoading(true)
            try {
                const data = await getVacancyTemplates('vacancy_template_type');
                setTemplates(data.vacancy_template_type)
                setLoading(false)
            } catch (error) {
                notify.errorsList(error.errors)
                setLoading(false)
            }
        };
        getTemplates();
        // eslint-disable-next-line
    }, [vacancyType])


    const [value, setValue] = React.useState(0);

    const handleChangeTemplate = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (templates.length) dispatch(setTemplateType(templates[value].name))
        // eslint-disable-next-line
    }, [templates, value])

    return (
        <section className={styles.vacancyManagerTemplates}>
            <VacancyTypeSwitcher />
            <TemplateTabs templates={templates} value={value} handleChange={handleChangeTemplate} loading={loading} />

            <SwitchTransition mode="out-in">
                <CSSTransition
                    key={value}
                    addEndListener={(node, done) => {
                        node.addEventListener('transitionend', done, false)
                    }}
                    classNames="fade"
                >
                    {!!templates && chosedTemplate ? <VacancyTemplateForm chosedTemplate={chosedTemplate} /> : <p>Loading...</p> || <p>Something went wrong!</p>}
                </CSSTransition>
            </SwitchTransition>

        </section>
    );
};

export default VacancyManagerTemplates;